(ns minorodata.components.connections.drawers
  (:require
   ["lucide-react" :refer [ChevronRight ExternalLink Info]]
   [applied-science.js-interop :as j]
   [clojure.string :as clojure.string]
   [goog.string :as gstring]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.app.utils :as app.utils]
   [minorodata.components.connections.extract-edit-form :as extract-edit-form
    :refer [maybe-add-downstream-config-blocks]]
   [minorodata.components.connections.extract-notification-form :as extract-notification-form]
   [minorodata.components.connections.forms.generator :as form-generator :refer [maybe-add-api-downstream-config
                                                                                 maybe-add-input-downstream-config]]
   [minorodata.components.schedule.core :as c.schedule]
   [minorodata.connections.list :as connections-list]
   [minorodata.utils :as utils]
   [mold-forms.core :as form-component]
   [mold-forms.model :refer [->form-model]]
   [re-posh.core :as re-posh]
   [reagent.core :as reagent]
   [ui.button]
   [ui.dialog :refer [dialog-actions dialog-title]]
   [ui.drawer]
   [ui.tooltip :refer [tooltip]]
   [ui.typography]))


;;
;; Warehouses
;;

(defn save-warehouse [{:keys [type on-close]}]
  (let [warehouse           @(re-posh/subscribe [:warehouse-data/pull])
        filestore           @(re-posh/subscribe [:filestore-data/pull])
        filestore-status    @(re-posh/subscribe [:filestore-status/pull])
        multi-warehouse?    @(re-posh/subscribe [:unleash/is-enabled "fe.snowflake-multiple-warehouses"])

        filestore-type       (:filestore-status/store filestore-status)
        warehouse-definition (utils/find-by-field connections-list/warehouses :id type)
        {:keys [name]}       warehouse-definition

        form-definition (:form warehouse-definition)
        form-defined?   (some? form-definition)
        initial-values  (merge warehouse filestore {:store-type filestore-type})]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      (if (some? warehouse)
        (str "Edit " name " connection")
        (str "Add " name " warehouse"))]

     (when form-defined?
       [form-generator/generate
        form-definition
        {:on-close       (fn [])
         :initial-values initial-values
         :submit         #(dispatch [:connections.api/save-warehouse-flow {:params % :on-close on-close}])
         :kleene-globals {:sink-type (:warehouse-data/sink-type warehouse)
                          :multi-warehouse? multi-warehouse?}}])]))


(defn delete-warehouse [{:keys [type on-close]}]
  (let [{warehouse-id :warehouse-data/id warehouse-type :warehouse-data/sink-type}
        @(re-posh/subscribe [:warehouse-data/pull])
        warehouse-definition (utils/find-by-field connections-list/warehouses :id type)

        params          {:id        warehouse-id
                         :sink-type warehouse-type
                         :json-data {}
                         :button    "delete"}]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      "Do you really wish to delete " (:name warehouse-definition) " connection settings?"]

     [dialog-actions
      [ui.button/button {:on-click   (fn []
                                       (dispatch [:connections.api/delete-warehouse params])
                                       (on-close))}
       "Delete warehouse"]]]))


;;
;; Filestores
;;

(defn save-filestore [{:keys [type on-close]}]
  (let [filestore            @(re-posh/subscribe [:filestore-data/pull])
        filestore-definition (utils/find-by-field connections-list/filestores :id type)
        {:keys [name]} filestore-definition
        form-definition  (:form filestore-definition)
        form-defined?    (some? form-definition)]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      (if (some? filestore)
        (str "Edit " name " connection")
        (str "Add " name " as Filestore"))]

     (when form-defined?
       [form-generator/generate
        form-definition
        {:on-close       on-close
         :initial-values filestore
         :submit         #(dispatch [:connections.api/save-filestore %])}])]))


(defn delete-filestore [{:keys [type on-close]}]
  (let [{:store-data/keys [region s3-key s3-secret]} @(re-posh/subscribe [:filestore-data/pull])
        filestore-definition (utils/find-by-field connections-list/filestores :id type)
        params           {:region    region
                          :s3-key    s3-key
                          :s3-secret s3-secret
                          :button    "delete"}]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      "Do you really wish to delete " (:name filestore-definition) " connection settings?"]


     [dialog-actions
      [ui.button/button {:on-click  (fn []
                                      (on-close)
                                      (dispatch [:connections.api/delete-filestore params]))}
       "Delete filestore"]]]))


;;
;; Sources
;;
(defn documentation-link-button
  [link connector-name]
  (when (and (some? link)
             (not (clojure.string/blank? link)))
    [:div {:class "mb-4"}
     [ui.button/button
      {:href       link
       :target     "_blank"
       :variant    :empty
       :size       :small
       :data-cy    "source-docs-btn"
       :icon-right ExternalLink}
      (str "How to set up " connector-name)]]))

(def by-request-message
  "To set up a connection to %s please submit a request to the customer success team using the email address success@kleene.ai")

(defn go-to-source [source]
  (dispatch [:app.events/navigate :source-details {:source-id (:source-id source)}]))

(defn create-source [{:keys [type on-close]}]
  (let [connector       @(re-posh/subscribe [:connections.subs/connector type])
        {:keys [name documentation-link by-request]}  connector
        form-definition (:form connector)
        form-defined?   (some? form-definition)]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      (str "Add " name " source")]

     [documentation-link-button documentation-link name]

     (if by-request
       [ui.typography/h4 {:class "my-2"}
        (gstring/format by-request-message name)
        [:br]]
       (when form-defined?
         [form-generator/generate
          form-definition
          {:on-close on-close
           :submit   (fn [data]
                       (dispatch [:connections.api/create-source
                                  data
                                  {:on-success go-to-source}]))}]))

     (when by-request
       [:div {:class "flex w-full justify-end"}
        [ui.button/button {:variant  :empty
                           :on-click on-close}
         "Ok"]])

     [:div {:class "grow"}]

     [:div
      [:span {:class "text-xs opacity-50"}
       (if (some? (:connector connector))
         ;; Jumper connectors have :connector and :version keys
         (str (:id connector) " v" (:version connector))
         ;; Legacy connectors will just display their ID
         (str (:id connector) " LATEST"))]]]))


(defn delete-source [{:keys [type id on-close]}]
  (let [connectors @(re-posh/subscribe [:connections.subs/current-connectors])
        connection (utils/find-by-field connectors :id type)]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      "Do you really wish to archive '" (:name connection) "' source?"]

     [dialog-actions
      [ui.button/button {:on-click  (fn []
                                      (on-close)
                                      (dispatch [:connections.api/delete-source id {:on-success #(dispatch [:app.events/navigate :extracts])}]))
                         :data-cy   "delete-source-confirm-btn"}
       "Archive source"]]]))


(defn edit-source [{:keys [type id on-close]}]
  (let [full-source     @(re-posh/subscribe [:source/pull [:source/source-id id]])
        connectors      @(re-posh/subscribe [:connections.subs/all-connectors])

        version         (get-in full-source [:source/source :version])

        connector       (app.utils/find-connector-by-type-and-version connectors type version)

        {:keys [name documentation-link]} connector

        form-definition (:form connector)
        form-defined?   (some? form-definition)
        initial-values  {:source      (:source/source full-source)
                         :name        (:source/name full-source)
                         :description (:source/description full-source)}]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      (str "Edit '" name "' source")]

     [documentation-link-button documentation-link name]

     (when form-defined?
       [form-generator/generate
        form-definition
        {:on-close       on-close
         :initial-values initial-values
         :params         full-source
         :submit         (fn [data]
                           (let [{:app-route/keys [name]} @(re-posh/subscribe [:app-route/pull])]
                             (dispatch [:connections.api/edit-source id data {:on-success (when (= :dag name) #(dispatch [:dag/load-dag-data]))}])))}])

     [:div {:class "grow"}]

     [:div
      [:span {:class "text-xs opacity-50"}
       (if (some? (:connector connector))
         ;; Jumper connectors have :connector and :version keys
         (str (:id connector) " v" (:version connector))
         ;; Legacy connectors will just display task-name or their ID
         (or (:source/task-name full-source)
             (str (:id connector) " LATEST")))]]]))


;;
;; Extracts
;;

(defn create-extract [{:keys [type id initial-values on-close]}]
  (let [connectors      @(re-posh/subscribe [:connections.subs/all-connectors])
        source          @(re-posh/subscribe [:source/pull [:source/source-id id]])

        version         (get-in source [:source/source :version])
        connector       (app.utils/find-connector-by-type-and-version connectors type version)

        {:keys [name]} connector
        form-definition (maybe-add-downstream-config-blocks (:extract-form connector) id)
        form-defined?   (some? form-definition)]

    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      (str "Add '" name "' extract")]

     (when form-defined?
       [form-generator/generate
        form-definition
        {:on-close       on-close
         :initial-values (merge initial-values
                                {:extract/source-id id})
         :kleene-globals {:uses-temporal (:source/uses-temporal source)}
         :submit         #(dispatch [:connections.api/create-extract id %])}])]))


(defn clone-extract [{:keys [type id meta on-close]}]
  (let [extract (:extract meta)
        cleaned-extract (dissoc extract
                                :extract/client-id
                                :extract/extract-id
                                :extract/master-id
                                :extract/last-run-at
                                :extract/last-run-status
                                :extract/created-by
                                :extract/updated-by
                                :extract/created-at
                                :extract/updated-at
                                :extract/order

                                ;; removing schedule
                                :extract/schedule-spec

                                :db/id)]

    [create-extract {:type           type
                     :id             id
                     :initial-values cleaned-extract
                     :on-close       on-close}]))


(defn delete-extract [{:keys [id on-close]}]
  (let [{:extract/keys [source-id extract-id name]} @(re-posh/subscribe [:extract/pull [:extract/extract-id id]])]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      "Do you really wish to delete "
      (if (some? name)
        (str "extract \"" name "\"")
        "this extract")
      "?"]

     [dialog-actions
      [ui.button/button {:on-click  (fn []
                                      (on-close)
                                      (dispatch [:connections.api/delete-extract
                                                 {:source-id source-id
                                                  :extract-id extract-id}]))
                         :data-cy    "delete-extract-confirm-btn"}
       "Delete extract"]]]))


(defn edit-extract []
  (reagent/create-class
   {:display-name "edit-extract"

    :component-did-mount
    (fn [this]
      (let [{:keys [id meta]} (reagent/props this)
            {:app-route/keys [name]}               @(re-posh/subscribe [:app-route/pull])
            {:extract/keys [source-id extract-id]} @(re-posh/subscribe [:extract/pull [:extract/extract-id id]])]
        (when (and (= name :source-details)
                   (not (:preserve-extract-query? meta)))
          (dispatch [:app.events/navigate :extract-details {:source-id  source-id
                                                            :extract-id extract-id}]))))

    :component-will-unmount
    (fn [this]
      (let [{:keys [id]} (reagent/props this)
            {:app-route/keys [name]}    @(re-posh/subscribe [:app-route/pull])
            {:extract/keys [source-id]} @(re-posh/subscribe [:extract/pull [:extract/extract-id id]])]
        (when (= name :extract-details)
          (dispatch [:app.events/navigate :source-details {:source-id source-id}]))))

    :render
    (fn [this]
      (let [{:keys [id on-close]} (reagent/props this)
            {:extract/keys [source-id name] :as extract} @(re-posh/subscribe [:extract/pull [:extract/extract-id id]])
            source @(re-posh/subscribe [:source/pull [:source/source-id source-id]])]
        [:div {:class ["grow flex flex-col max-w-[450px] h-full" "break-words"]}
         [dialog-title {:class "mb-6"}
          "Editing extract"
          (when (some? name) (str " " name))]

         [extract-edit-form/extract-edit-form
          {:extract  extract
           :source   source
           :on-close on-close}]]))}))


(defn unschedule-confirmation []
  (let [dialog-open? (reagent/atom false)]
    (fn [{:keys [update-extract]}]
      [:<>

       [:div
        [ui.button/button {:size :small
                           :variant :empty
                           :class "ml-1"
                           :on-click #(do
                                        (j/call % :stopPropagation)
                                        (reset! dialog-open? true))}
         "Unschedule"]]

       [ui.dialog/dialog {:open           @dialog-open?
                          :title          "Unschedule extract"
                          :on-open-change #(reset! dialog-open? false)
                          :content-props {:size :small}
                          :content [:div
                                    [:div
                                     [:p
                                      "This action will unschedule this extract" [:br]
                                      [:strong "Are you sure you want to proceed?"]]]

                                    [:div {:class "mt-4 flex flex-row gap-2"}

                                     [ui.button/button {:variant :secondary
                                                        :on-click #(reset! dialog-open? false)}
                                      "Cancel"]

                                     [ui.button/button {:on-click  #(do
                                                                      (reset! dialog-open? false)
                                                                      (update-extract nil))}
                                      "Sure"]]]}]])))


(defn schedule-extract [{:keys [type id on-close]}]
  (let [{:extract/keys [config] :as extract} @(re-posh/subscribe [:extract/pull [:extract/extract-id id]])
        timezone          @(re-posh/subscribe [:app.subs/timezone])
        connectors        @(re-posh/subscribe [:connections.subs/all-connectors])
        version           (get-in config [:extracts 0 :version])
        connector         (app.utils/find-connector-by-type-and-version connectors type version)
        form-definition   (:extract-form connector)
        format-for-api    (:format-for-api form-definition)
        format-for-inputs (:format-for-inputs form-definition)
        {:extract/keys [name extract-id source-id]} extract
        update-extract    (fn [schedule]
                            (let [{:keys [cron]} schedule
                                  api-data (-> extract
                                               format-for-inputs
                                               (maybe-add-input-downstream-config extract)
                                               format-for-api
                                               (maybe-add-api-downstream-config extract)
                                               (app.utils/assoc-some :schedule-spec (when cron {:cron cron})))]
                              (dispatch [:connections.api/edit-extract
                                         {:source-id        source-id
                                          :extract-id       extract-id
                                          :data             api-data
                                          :schedule-change? true}])
                              (on-close)))
        cron (app.utils/->cron extract)]
    [:div
     [dialog-title {:class "mb-6"}
      "Schedule extract"
      (when (some? name) (str " '" name "'"))]

     [form-component/form
      (->form-model
       {:id        :extract-scheduler
        :on-submit (fn [form-data]
                     (let [schedule (form-component/model->fields form-data)]
                       (update-extract schedule)))
        :clean-up  #(dispatch [:form-model/delete [:form-model/id :extract-scheduler]])
        :validate  (partial form-component/validate-form ::c.schedule/schedule-form)
        :fields    [{:name :cron :value cron :process identity}]})
      (fn [fields errors on-submit]
        (let [any-error (->> errors vals (map :value) first)]
          [:form {:on-submit on-submit :key fields}

           [:div {:class "flex justify-between"}
            [:div {:class "flex-1"}
             [ui.typography/h3 "Current schedule (" timezone " time zone)"]]

            (when (:extract/schedule-spec extract)
              [unschedule-confirmation {:update-extract update-extract}])]

           [ui.typography/h4 {:class "text-kleene-primary-v2 mb-4"}
            (app.utils/format-schedule
             {:cron            (get-in fields [:cron :value])
              :empty-status    "Not scheduled"
              :required-fields [:minute]})]

           [:hr {:class "py-4"}]

           [c.schedule/cron-editor {:field (:cron fields)}]

           (when (some? any-error)
             [:div {:class "mt-4 mb-4"}
              [:span {:class "text-kleene-error-01"} any-error]])

           [dialog-actions
            [ui.button/button {:type    "submit"
                               :data-cy "extract-schedule-submit-btn"}
             "Submit schedule"]]]))]]))



;;
;;Recipes
;;

(defn create-recipe [{:keys [type on-close]}]
  (let [recipes      @(re-posh/subscribe [:recipes.subs/recipes])
        recipe       (utils/find-by-field recipes :recipe/recipe-id type)

        {:recipe/keys [name]}  recipe
        form-definition (:recipe/form-definition recipe)
        form-defined?   (some? form-definition)]
    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      (str "Add '" name "' recipe")]

     (when form-defined?
       [form-generator/generate
        form-definition
        {:on-close (fn [])
         :submit   #(dispatch [:recipes.api/compile-template type on-close %])}])

     [:div {:class "grow"}]

     [:div
      [:span {:class "text-xs opacity-50"}
       (str "version:" (:recipe/version recipe))]]]))


(defn show-source-recipes []
  (let [all-recipes      @(re-posh/subscribe [:recipes.subs/recipes])
        recipes          (filter :recipe/enabled all-recipes)]

    [:div {:class "grow flex flex-col max-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      "Deploy available recipes"]


     [:div {:class "divide-y divide-gray-100 dark:divide-gray-600 mb-5 mt-5 min-w-[400px]"}
      (map (fn [recipe]
             (let [{:recipe/keys [name recipe-id]} recipe]
               [:div {:class "relative flex justify-between gap-x-6 px-4 py-5 hover:bg-gray-50 dark:hover:bg-kleene-highlight  sm:px-6 lg:px-8 cursor-pointer"
                      :key   recipe-id
                      :on-click (fn []
                                  (dispatch [:recipes.events/load-recipe-details recipe-id]))}
                [:div {:class "flex gap-x-4"}
                 [:div (str name)]]

                [:> ChevronRight {:class "h-5 w-5 flex-none text-gray-400"}]]))
           recipes)]

     [:div {:class "grow"}]]))


(defn set-notification [{:keys [id]}]
  (let [{:extract/keys [master-id]} @(re-posh/subscribe [:extract/pull [:extract/extract-id id]])
        notification                @(re-posh/subscribe [:notifications.subs/job-notification master-id])
        account-settings            @(re-posh/subscribe [:account-notifications/pull])]

    [:div {:class "grow flex flex-col min-w-[450px] h-full"}
     [dialog-title {:class "mb-6"}
      "Notifications"]

     [:div {:class "flex justify-between"}
      [:header {:class "flex gap-2 items-center mb-4"}
       [ui.typography/h3 "Notify when extract execution state changes"]
       [tooltip {:content "You will receive a notification when the latest extract execution status is different from the previous one."}
        [:> Info {:size 20}]]]]

     [:f> extract-notification-form/extract-notification-form
      {:master-id        master-id
       :notification     notification
       :account-settings account-settings
       :on-success       [:connector/delete]}]]))



(defn close-drawer []
  (dispatch [:connector/delete]))


(def connectors-mapping
  {:save-warehouse                    save-warehouse
   :delete-warehouse                  delete-warehouse
   :save-filestore                    save-filestore
   :delete-filestore                  delete-filestore
   :create-source                     create-source
   :edit-source                       edit-source
   :delete-source                     delete-source
   :create-extract                    create-extract
   :clone-extract                     clone-extract
   :edit-extract                      edit-extract
   :delete-extract                    delete-extract
   :schedule-extract                  schedule-extract
   :show-source-recipes               show-source-recipes
   :create-recipe                     create-recipe
   :set-notification                  set-notification})


(defn drawers []
  (let [{:connector/keys [action type id meta] :as connector} @(re-posh/subscribe [:connector/pull])
        drawer-component (get connectors-mapping action)
        valid-drawer?    (some? drawer-component)]
    [ui.drawer/drawer {:origin         "right"
                       :open           valid-drawer?
                       :on-open-change close-drawer
                       :content-wrapper-class "h-full mt-0"
                       :content-props {:size       :smallish
                                       :class      "w-auto"
                                       :no-padding false}
                       :content (if valid-drawer?
                                  [:div {:class  "flex flex-col min-h-full pb-kai"}
                                   [:div {:class "h-full grow flex flex-col"}
                                    [drawer-component
                                     {:type      type
                                      :id        id
                                      :meta      meta
                                      :on-close  close-drawer
                                      :connector connector}]]]

                                  ;; This is here to keep the form from collapsing too fast when form disappears
                                  [:div {:class "w-[418px]"}])}]))
